// @flow
import * as React from 'react';
import styled, {keyframes} from 'styled-components';
import Image from 'components/Image';
import Img360Arrow from 'assets/images/driving-zone/b/img-b-03-360-arrow.svg';

export default function Icon360Degree(props: any): React.Element<any> {
  return (
    <IconWrapper {...props}>
      <div>
        <img src={Img360Arrow} alt="" />
        <img src={Img360Arrow} alt="" />
        <img src={Img360Arrow} alt="" />
        <img src={Img360Arrow} alt="" />
      </div>
      <Image source="./driving-zone/b/img-b-03-360-icon.png" />
      <div>
        <img src={Img360Arrow} alt="" />
        <img src={Img360Arrow} alt="" />
        <img src={Img360Arrow} alt="" />
        <img src={Img360Arrow} alt="" />
      </div>
    </IconWrapper>
  );
}

const FadeInOut1 = keyframes`
  0% {
    opacity: 0.0;
  }
  50% {
    opacity: 1.0;
  }
  100% {
    opacity: 0.0;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;

  > div {
    display: inline-block;
    > img {
      width: ${(props) => (props.theme.layout.mobile ? 20 : 33)}px;
      height: ${(props) => (props.theme.layout.mobile ? 35 : 56)}px;
    }
  }

  > img {
    width: ${(props) => (props.theme.layout.mobile ? 83 : 133)}px;
    height: ${(props) => (props.theme.layout.mobile ? 56 : 89)}px;
    padding-top: ${(props) => (props.theme.layout.mobile ? 0 : 0)}px;
    padding-left: ${(props) => (props.theme.layout.mobile ? 50 : 100)}px;
    padding-right: ${(props) => (props.theme.layout.mobile ? 50 : 100)}px;
  }
  > * > img {
    animation: ${FadeInOut1} 1.8s;
    animation-iteration-count: infinite;
  }

  >:nth-child(1) {
    > img {
      padding-top: ${(props) => (props.theme.layout.mobile ? 8 : 13)}px;
    }
    >:nth-child(1) {
      animation-delay: 0.7s;
    }
    >:nth-child(2) {
      animation-delay: 0.5s;
    }
    >:nth-child(3) {
      animation-delay: 0.3s;
    }
    >:nth-child(4) {
      animation-delay: 0.0s;
    }
  }
  >:nth-child(3) {
    > img {
      padding-bottom: ${(props) => (props.theme.layout.mobile ? 8 : 13)}px;
      transform: rotate(180deg);
    }
    >:nth-child(1) {
      animation-delay: 0.0s;
    }
    >:nth-child(2) {
      animation-delay: 0.3s;
    }
    >:nth-child(3) {
      animation-delay: 0.5s;
    }
    >:nth-child(4) {
      animation-delay: 0.7s;
    }
  }
`;
